import { Controller } from "@hotwired/stimulus";

export default class extends Controller {
  static targets = ["check", "accept"];
  static values = { 
    publishedAt: String,
    manualOpen: { type: Boolean, default: false }
  };

  modal = $("[data-remodal-id=modalTerm]").remodal({
    hashTracking: false,
    closeOnEscape: false,
    closeOnOutsideClick: false,
  });

  connect() {
    this.updateAcceptButtonEventListener = this.updateAcceptButton.bind(this);
    for (const checkBox of this.checkTargets) {
      checkBox.addEventListener("change", this.updateAcceptButtonEventListener);
    }
    this.updateAcceptButton();

    if (this.manualOpenValue) {
      document.addEventListener("requestOpenTermModal", this.openModal.bind(this));
    } else {
      this.openModal();
    }
  }

  disconnect() {
    for (const checkBox of this.checkTargets) {
      checkBox.removeEventListener("change", this.checkChangeEventListener);
    }

    if (this.manualOpenValue) {
      document.removeEventListener("requestOpenTermModal", this.openModal.bind(this));
    }
  }

  openModal() {
    this.modal.open();
  }

  submit() {
    document.cookie = `show_term_date=${this.publishedAtValue}; path=/; max-age=315360000;`; // 無期限
    this.element.dispatchEvent(new CustomEvent("termAccepted"));
    this.modal.close();
  }

  updateAcceptButton() {
    for (const checkBox of this.checkTargets) {
      if (!checkBox.checked) {
        this.disableAcceptButton();
        return;
      }
    }
    this.enableAcceptButton();
  }

  disableAcceptButton() {
    this.acceptTarget.disabled = true;
    this.acceptTarget.classList.add("is-disabled");
  }

  enableAcceptButton() {
    this.acceptTarget.disabled = false;
    this.acceptTarget.classList.remove("is-disabled");
  }
}
